import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Card, Button, Row, Col, Form } from "react-bootstrap";
import Layout from "../../layout/default";
import Block from "../../components/Block/Block";
import { Icon } from "../../components";
// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";
// import FormControl from "@mui/material/FormControl";
import { rootURL } from "../utilities/axios-config";
import { successMessage, failedMessage } from "../utilities/alert-config";

function MagScrappingSourcesAdd() {
  const history = useNavigate();
  const [sourceData, setSourceData] = useState({
    name: "",
    url: "",
  });

  //const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSourceData({
      ...sourceData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!sourceData.name || !sourceData.url) {
      failedMessage("Please fill all fields");
      return;
    }

    const userToken = localStorage.getItem("userToken");
    setLoading2(true);

    const tagObj = {
      name: sourceData.name,
      url: sourceData.url,
      type: "scrapper",
      status: "active",
    };

    fetch(`${rootURL}/magazine-scrapping-sources`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${userToken}`,
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(tagObj),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success === true) {
          successMessage("Success");
          //   console.log("data", result)
          setTimeout(() => {
            history(`/mag-scrapping-sources/list`);
          }, 3000);
        } else if (result.success === false) {
          setLoading2(false);
          failedMessage(result.message);
        }
      })
      .catch((error) => {
        setLoading2(false);
        failedMessage("Internal Server Error");
      })
      .finally(() => {
        setLoading2(false);
      });
  };

  return (
    <Layout title="Scrapping Source Add" content="container">
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <ul className="d-flex gap g-2">
              <li className="d-none d-md-block">
                <Link
                  to={`/mag-scrapping-sources/list`}
                  className="btn btn-soft btn-primary"
                >
                  <Icon name="user"></Icon>
                  <span>Scrapping Sources</span>
                </Link>
              </li>
              {/* <li className="d-md-none">
                <Link
                  to={`/magcategory-manage/magcategory-list`}
                  className="btn btn-soft btn-primary btn-icon"
                >
                  <Icon name="user"></Icon>
                </Link>
              </li> */}
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>
      <Block>
        <Card className="card-gutter-md">
          <Card.Body>
            <div className="bio-block">
              <h4 className="bio-block-title mb-4">Add Scrapping Source</h4>
              <Form onSubmit={handleSubmit}>
                <Row className="g-3">
                  <Col lg="6">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="first_name">Name *</Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control
                          type="text"
                          id="name"
                          name="name"
                          value={sourceData.name}
                          placeholder="Name"
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col lg="6">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="first_name">URL *</Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control
                          type="text"
                          id="url"
                          name="url"
                          value={sourceData.url}
                          placeholder="URL"
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg="12">
                    <Button variant="primary" type="submit">
                      {loading2 ? "Saving...." : "Save"}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Card.Body>
        </Card>
      </Block>
    </Layout>
  );
}

export default MagScrappingSourcesAdd;
